import {
  Typography,
  MenuItem,
  Button,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Paper,
} from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import BarCode from "react-barcode";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import TimeIcon from "@material-ui/icons/AccessTime";
import LocationIcon from "@material-ui/icons/LocationOn";
import LabelForm from "../../../partials/labelForm";
import { withStyles } from "@material-ui/core/styles";
import SelectedBranch from "../../selectedBranch";
import { toLocalTime, toUTC } from "../../formatUTC";
import DescriptionComponent from "../../descriptionComponent";
import InputFileReader from "../../fileReader";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import ImageGallery from "../../imageGallery";
import NumberFormatCustom from "../../numberFormat";
import { isJsonString } from "../../../utils/setting";
import { getOriginalImage } from "../../../utils/setting";
import "../../../css/voucher.css";
import InputFormat from "../../../partials/inputForm";
import SelectDateTime from "../../../partials/selectDateTime";
import { getNumberOnString } from "../../../partials/validateNumber";
const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(2),
  },
  card: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 500,
    maxWidth: 500,
  },
  media: {
    objectFit: "cover",
  },
  cardContent: {
    position: "absolute",
    paddingTop: 0,
  },
  nameSpa: {
    fontSize: 30,
    textTransform: "uppercase",
    fontWeight: 500,
    // letterSpacing: 8
  },
  textWhite: {
    color: "#fff",
  },
  address: {
    fontSize: 12,
    dispatch: "inline-block",
  },
  wrapperAddress: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    // borderBottom: '1px solid #ccc',
  },
  wrapperEndedDate: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  textRed: {
    color: "#ffb5ae",
  },
  endedDate: {
    fontSize: 12,
  },
  cardContentCode: {
    padding: 0,
    paddingBottom: 0,
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  wrapperCode: {
    padding: "10px 20px",
    borderBottomRightRadius: 20,
    borderTopRightRadius: 20,
    backgroundColor: "#FF513F",
    margin: "0",
  },
  discount: {
    fontSize: 16,
  },
  wrapperDiscount: {
    padding: "8px 20px",
    margin: "0",
  },
  wrapperQR: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "10px 20px",
    fontSize: 28,
    color: "#fff",
    cursor: "pointer",
  },
  voucher: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  customFormLabel: {
    display: "block",
    transformOrigin: "top left",
    transform: "translate(0, 1.5px) scale(0.75)",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  inputType: {
    height: "unset",
  },
});
const types = [
  {
    value: "percent",
    label: "Percent",
  },
  {
    value: "value",
    label: "Value",
  },
];
class CardVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        ...this.props.data,
        discount:
          this.props.data.type == "percent"
            ? this.props.data.discount * 100
            : this.props.data.discount,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      if (nextProps.data.type == "percent") nextProps.data.discnount *= 100;
      this.setState({ data: { ...nextProps.data } });
    }
  }
  getCode = (code) => {
    var arr = code.split("-");
    return arr[arr.length - 1];
  };
  getFormattedDate = (date) => {
    return toLocalTime(date);
  };
  changeArrBranch = (arrBranch) => {
    let data = this.state.data;
    data.arrBranch = JSON.stringify(arrBranch);
    this.setState(data);
  };
  handleInputChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let data = this.state.data;
    if (event.target.type === "checkbox") {
      value = event.target.checked ? 1 : 0;
    }
    if (name === "itemTime" || name === "times" || name === "discount") {
      value = getNumberOnString(value);
    }
    data[name] = value;
    this.setState({ data });
  };
  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };
  handleChangeDate = (name, date) => {
    var data = this.state.data;
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    data[name] = milisecondInLocal;
    this.setState({ data });
  };
  handleSubmitUpdate = async (data) => {
    let check = await this.props.voucherDispatch.updateVoucher({
      voucher: data,
      arrBranch: data.arrBranch,
    });
    this.loading.stopLoading();
    this.props.finishUpdate(check);
  };
  handleUploadImage = async () => {
    this.loading.startLoading();
    var { t } = this.props;
    var data = this.state.data;
    data.startedDate = toUTC(data.startedDate);
    data.endedDate = toUTC(data.endedDate);
    data.itemTime = data.itemTime || 0;
    data.times = data.times || 1;
    if (this.InputFileReader.getFile() !== null) {
      let check = await this.props.uploadDispatch.saveStorage({
        files: this.InputFileReader.getFile(),
        code: this.props.serviceCode,
        imgPre: data.imgVoucher,
        type: "img-voucher",
      });
      if (check.code === 1) {
        data.imgVoucher = check.data.previewLink;
        data.discount = Number(data.discount);
        if (data.type == "percent") data.discount /= 100;
        this.handleSubmitUpdate(data);
      } else {
        this.handleSubmitUpdate(data);
        this.mSnackbar.handleClick(
          t("voucher_addvoucher_upload_image_unsuccessfully") +
            " " +
            check.message,
          "error"
        );
      }
    } else if (this.InputFileReader.getSrc() !== null) {
      data.imgVoucher = this.InputFileReader.getSrc();
      this.handleSubmitUpdate(data);
    } else if (
      this.InputFileReader.getFile() === null &&
      data.imgVoucher &&
      this.InputFileReader.getFlagEdit()
    ) {
      data.imgVoucher = null;
      this.handleSubmitUpdate(data);
    } else {
      this.handleSubmitUpdate(data);
    }
  };
  handleCheck = () => {
    let voucher = this.state.data;
    let { t } = this.props;
    voucher.discount = Number(voucher.discount);
    if (voucher.type == "percent") voucher.discount /= 100;
    if (!voucher.arrBranch.length && voucher.forAll == 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_nothing_apply_branch"),
        "warning"
      );
    else if (voucher.discount === 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_discount"),
        "warning"
      );
    else if (!voucher.startedDate)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_startedDate_discount"),
        "warning"
      );
    else if (!voucher.endedDate)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_endedDate_discount"),
        "warning"
      );
    else if (voucher.endedDate - voucher.startedDate < 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_endedDate_more_than_startedDate"),
        "warning"
      );
    else if (!voucher.title)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_title"),
        "warning"
      );
    else if (!voucher.shortDescription)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_shortDescription"),
        "warning"
      );
    else if (voucher.type === "percent" && voucher.discount > 1)
      this.mSnackbar.handleClick(
        t(
          "voucher_addvoucher_please_enter_discount_less_than_or_equal_to_100_for_percent"
        ),
        "warning"
      );
    else {
      this.handleUploadImage();
    }
  };
  updateImageGallery = async (imageGallery) => {
    let { t } = this.props;
    imageGallery = imageGallery.map((e) => getOriginalImage(e));
    this.loading.startLoading();
    let data = {
      serviceCode: this.state.data.serviceCode,
      code: this.state.data.code,
      imageGallery: JSON.stringify(imageGallery),
    };
    let check = await this.props.voucherDispatch.updateImageGallery({
      voucher: data,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_upload_image_in_gallery_successfully")
      );
      this.props.finishUpdateImageGallery();
    } else {
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_upload_image_in_gallery_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  };
  handleSelectImage = async (data) => {
    let { t } = this.props;
    this.loading.startLoading();
    let checkUpload = await this.props.uploadDispatch.saveStorage({
      files: data.e.target.files[0],
      code: this.props.serviceCode,
      type: "img-voucher",
    }); // serviceCode lấy từ roleId
    this.loading.stopLoading();
    if (checkUpload.code === 1) {
      let imageGallery = data.imageGallery.map((e) => getOriginalImage(e));
      imageGallery.push(checkUpload.data.previewLink);
      this.updateImageGallery(imageGallery);
    } else
      this.mSnackbar.handleClick(
        t("service_ownerspa_service_album_create_album_unsuccess"),
        "error"
      );
  };
  deleteImage = async (data) => {
    let { t } = this.props;
    let imageGallery = data.imageGallery;
    let position = -1;
    imageGallery.map((image, index) => {
      if (image == data.imageDelete) position = index;
    });
    if (position != -1) imageGallery.splice(position, 1);
    this.updateImageGallery(imageGallery);
  };
  render() {
    const { classes, t, listBranch } = this.props;
    const { data } = this.state;
    if (data.arrBranch && isJsonString(data.arrBranch))
      data.arrBranch = JSON.parse(data.arrBranch);
    const branch = data.arrBranch;
    let filterBranch = [];
    if (branch) {
      branch.forEach((e) => {
        let find = listBranch.find((i) => i.branchCode === e);
        if (find) {
          filterBranch.push(find);
        }
      });
    }
    return (
      <Paper className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <InputFormat
              label={t("voucher_listvoucher_tablehead_discount")}
              name="discount"
              required
              placeholder={"0"}
              value={data.discount}
              onChange={this.handleInputChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: (
                  <InputAdornment position="end">
                    {data.type === "percent" ? "%" : this.props.currencyCode}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <InputFormat
              label={t("voucher_listvoucher_tablehead_times")}
              name="times"
              required
              value={data.times}
              onChange={this.handleInputChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {t("menu_menuitem_editmenuitem_times")}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <InputFormat
              label={t("voucher_listvoucher_tablehead_item_time")}
              name="itemTime"
              required
              value={data.itemTime}
              onChange={this.handleInputChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {t("menu_menuitem_editmenuitem_minute")}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <InputFormat
              select
              label={t("voucher_listvoucher_tablehead_type")}
              name="type"
              required
              value={data.type}
              onChange={this.handleInputChange}
            >
              {types.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value === "value"
                    ? this.props.currencyCode
                    : t(option.value)}
                </MenuItem>
              ))}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SelectDateTime
              label={t("voucher_listvoucher_tablehead_start_date")}
              name="startedDate"
              required
              margin="none"
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              onChange={(date) => this.handleChangeDate("startedDate", date)}
              value={data.startedDate}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SelectDateTime
              label={t("voucher_listvoucher_tablehead_end_date")}
              name="endedDate"
              required
              margin="none"
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              onChange={(date) => this.handleChangeDate("endedDate", date)}
              value={data.endedDate}
            />
          </Grid>
          {!data.forAll ? (
            <Grid item xs={12}>
              <SelectedBranch
                onRef={(id) => (this.SelectedBranch = id)}
                multiple={true}
                disabled={data.forAll == 1}
                value={branch}
                handleChangeBranch={(arrBranch) =>
                  this.changeArrBranch(arrBranch)
                }
              />
            </Grid>
          ) : (
            ""
          )}
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={data.forAll == 1 ? true : false}
                  name="forAll"
                  onChange={this.handleInputChange}
                />
              }
              className={classes.label}
              label={t("voucher_listvoucher_cardvoucher_all_branch")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <InputFormat
              label={t("voucher_listvoucher_cardvoucher_title")}
              name="title"
              required
              value={data.title}
              onChange={this.handleInputChange}
              inputProps={{
                maxLength: 255,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <InputFormat
              required
              label={t("voucher_listvoucher_cardvoucher_shortDescription")}
              name="shortDescription"
              value={data.shortDescription}
              onChange={this.handleInputChange}
              inputProps={{
                maxLength: 255,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              title={t("voucher_listvoucher_cardvoucher_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={data.description}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
            <LabelForm label={t("voucher_addvoucher_image_voucher")} />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <InputFileReader
              onRef={(id) => (this.InputFileReader = id)}
              style={classes}
              container="square"
              defaultImg={
                data.imgVoucher || data.imageUrl || "/images/noneImage.svg"
              }
              selectStorageMode={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.wrapButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCheck}
            >
              {t("voucher_addvoucher_save")}
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
            <LabelForm label={t("voucher_preview_voucher")} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.voucher}>
            <Card className={classes.card + " overlay-image"} raised>
              <CardMedia
                component="img"
                className={classes.media}
                height="200"
                width="500"
                image={
                  data.imgVoucher || data.imageUrl || "/images/noneImage.svg"
                }
                title="VOUCHER IMAGE"
              ></CardMedia>
              <span className={classes.wrapperQR}>
                <QRCode
                  value={data.code}
                  size={32}
                  fgColor="#000000"
                  bgColor="#ffffff"
                  level="L"
                  renderAs="svg"
                />
              </span>
              <CardContent className={classes.cardContent}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      className={classNames(classes.nameSpa, classes.textWhite)}
                      align="left"
                      variant="h6"
                      component="h1"
                    >
                      {data.name}
                    </Typography>
                  </Grid>
                  {filterBranch.length && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      className={classes.wrapperAddress}
                    >
                      <div>
                        <LocationIcon className={classes.textWhite} />
                        &nbsp;&nbsp;
                      </div>
                      <div>
                        {filterBranch.map((e) => {
                          return (
                            <Typography
                              align="left"
                              className={classNames(
                                classes.address,
                                classes.textWhite
                              )}
                              component="div"
                            >
                              {e.address}
                            </Typography>
                          );
                        })}
                      </div>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    className={classes.wrapperEndedDate}
                  >
                    <TimeIcon timeicon="true" className={classes.textWhite} />
                    &nbsp;&nbsp;
                    <Typography
                      align="left"
                      className={classNames(
                        classes.endedDate,
                        classes.textWhite
                      )}
                      component="div"
                    >
                      {t("voucher_listvoucher_cardvoucher_end_date")}:&nbsp;
                    </Typography>
                    <Typography
                      align="center"
                      component="div"
                      className={classNames(classes.endedDate, classes.textRed)}
                    >
                      {this.getFormattedDate(data.endedDate)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className={classes.cardContentCode}>
                <div className={classes.wrapperCode}>
                  <Typography
                    className={classNames(classes.code, classes.textWhite)}
                    align="center"
                    component="h1"
                  >
                    {this.getCode(data.code)}
                  </Typography>
                </div>
                <div className={classes.wrapperDiscount}>
                  <Typography
                    className={classNames(classes.discount, classes.textWhite)}
                    align="center"
                    component="h1"
                  >
                    {t("voucher_listvoucher_cardvoucher_discount")}:{" "}
                    <span>
                      <NumberFormat
                        thousandSeparator={true}
                        displayType={"text"}
                        value={data.discount}
                      />
                    </span>
                    <span>
                      {data.type === "percent" ? "%" : this.props.currencyCode}
                    </span>
                  </Typography>
                </div>
              </CardActions>
            </Card>
            <QRCode
              value={data.code}
              size={128}
              fgColor="#000000"
              bgColor="#ffffff"
              level="L"
              renderAs="svg"
            />
            <BarCode
              value={data.code}
              height={112}
              lineColor="#000000"
              background="#ffffff"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
            <LabelForm label={t("voucher_image_gallery")} />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <ImageGallery
              imageGallery={data.imageGallery}
              handleSelectImage={this.handleSelectImage}
              deleteImage={this.deleteImage}
              updateImageGallery={this.updateImageGallery}
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

CardVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  voucherDispatch: dispatch.voucher,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CardVoucher)
  )
);
